import { render, staticRenderFns } from "./Softwares.vue?vue&type=template&id=282b2a00&"
import script from "./Softwares.vue?vue&type=script&lang=js&"
export * from "./Softwares.vue?vue&type=script&lang=js&"
import style0 from "./Softwares.vue?vue&type=style&index=0&id=282b2a00&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports